// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Row, Col, Card, Popconfirm } from "antd";
import DownloadBtn from "../downloadbtn";
import ShareBtn from "../shareBtn";
import ItemTag from "../itemtag";

type Props = {
  id: string,
  thumbUrl: Object,
  name: string,
  icon: string,
  onItemSelect: Function,
  onTagClicked: Function,
  onRemoveTag: Function,
  onRemoveItem: Function,
  publishDate: string,
  tags: Array<string>,
  files: Array<Object>,
  tagById: Object,
  editMode: boolean
};

type ItemProps = {
  id: string,
  editMode: boolean,
  removeItem: Function
};

const UpublishBtn = ({ id, editMode, removeItem }: ItemProps) => {
  const _onClick = () => {
    removeItem(id);
    console.log("unpublish id ", id);
  };

  return editMode ? (
    <Popconfirm
      placement="bottomRight"
      title="Are you sure delete this task?"
      onConfirm={_onClick}
      okText="Yes"
      cancelText="No"
    >
      <Icon className="unpublish" type="close-circle" />
    </Popconfirm>
  ) : null;
};

class ThumbItem extends Component<Props> {
  shouldComponentUpdate(nextProps: Object) {
    const { editMode: nextEditMode } = nextProps;
    const { editMode } = this.props;

    const { id: nextid } = nextProps;
    const { id } = this.props;

    return nextid !== id || nextEditMode !== editMode;
  }
  // componentDidUpdate() {
  //   console.log("componentDidUpdate");
  // }

  formatDate = (date: string): string => {
    const _date = new Date(date);
    return _date.toLocaleDateString();
  };

  selectItem = () => {
    const { id, onItemSelect } = this.props;
    onItemSelect(id);
  };

  render() {
    const {
      id,
      name,
      thumbUrl,
      icon,
      publishDate,
      tags,
      files,
      tagById,
      onTagClicked,
      onRemoveTag,
      onRemoveItem,
      editMode
    } = this.props;
    return (
      <Col
        id={id}
        xs={24}
        sm={12}
        md={12}
        lg={8}
        xl={6}
        xxl={4}
        style={{ padding: "15px 8px" }}
      >
        <Card
          title={
            <span title={name}>
              <Icon className="icon" type={icon} /> {name}
            </span>
          }
          style={{ display: "block" }}
          bodyStyle={{ padding: 0 }}
          extra={
            <UpublishBtn id={id} {...this.props} removeItem={onRemoveItem} />
          }
        >
          <Link to={`/details/${id}`}>
            <div className="custom-image" onClick={this.selectItem}>
              {thumbUrl &&
                thumbUrl !== "" && (
                  <img alt={name} width="100%" src={thumbUrl} />
                )}
              <Row
                className="img-overlay"
                type="flex"
                align="middle"
                justify="center"
              >
                <Icon className="icon" type="eye" />
              </Row>
            </div>
          </Link>
          <div className="custom-card">
            <h4>{this.formatDate(publishDate)}</h4>
            {tagById &&
              tags.map(tag => {
                return tagById[tag] !== undefined ? (
                  <ItemTag
                    key={tag}
                    id={tag}
                    itemId={id}
                    name={tagById[tag].name}
                    tagClicked={onTagClicked}
                    removeTag={onRemoveTag}
                    editMode={editMode}
                  />
                ) : (
                  console.log("tag non presente nella lista ", tag)
                );
              })}
            <div className="btns-wrapper">
              <DownloadBtn direction="up" clsName="btn-white" files={files} />
              <ShareBtn direction="up" clsName="btn-white" files={files} />
            </div>
          </div>
        </Card>
      </Col>
    );
  }
}

export default ThumbItem;



// WEBPACK FOOTER //
// ./src/components/thumbitem/index.js